module.exports = __webpack_public_path__ + "static/img/coin_c.e3b96dec.png";